// extracted by mini-css-extract-plugin
module.exports = {"container":"ImportantNow_container__1wsSq","title":"ImportantNow_title__32rjK","option":"ImportantNow_option__30EO2"};